import { StyleSheet } from 'aphrodite/no-important';
import { palettes, spacers } from '@trainline/depot-web/css';

export default StyleSheet.create({
  groupWrapper: {
    marginTop: 0,
    marginBottom: 0,
    display: 'flex',
    flexFlow: 'row',
    border: `1px solid ${palettes.dp_app_border_base}`,
    borderTop: 0, //reset the top to avoid double
    alignItems: 'center',
    background: palettes.dp_app_backdrop_white,
    ':last-child': {
      borderRadius: `0 0 ${spacers.dp_s8} ${spacers.dp_s8}`,
    },
  },
  journeyWrapper: {
    flexGrow: 1,
  },
  pendingGroup: {
    marginTop: spacers.dp_s24,
    borderTop: `1px solid ${palettes.dp_app_border_base}`,
    borderRadius: spacers.dp_s8,
    ':last-child': {
      borderRadius: spacers.dp_s8,
    },
  },
  date: {
    height: '100%',
    width: 300,
    textAlign: 'center',
    padding: `${spacers.dp_s12} ${spacers.dp_s24}`,
  },
});
